/* ==========================================================================
   Upsell-popup
   --------------------------------------------------------------------------
   Fångar "Lägg till i varukorgen" PÅ PDP i capture-fas, INNAN temats egna
   handler hinner köra sitt /cart/add.js-anrop. Det gör att UpCart (som
   lyssnar på add-anropet) inte triggas förrän kunden agerat i popupen.

   Flöde:
     1. Kund klickar "Lägg till"  -> vi preventDefault + stopImmediatePropagation
                                       -> popup öppnas, UpCart är tyst.
     2. Kund väljer deals.
     3. Kund klickar "Fortsätt"   -> ETT /cart/add.js-anrop (huvudprodukt +
                                       valda deals) -> UpCart öppnas precis
                                       som idag.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__upsellPopupInit) return;
  window.__upsellPopupInit = true;

  // UpCart äger varukorgs-drawern (patchar fetch/XHR och öppnar sin egen).
  // Vi rör INTE temats native drawer — uppdaterar bara temats header-räknare.
  var SECTIONS = [
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  var popup = null;
  var capturedData = null;
  var busy = false;
  var bound = false;
  var prevBodyOverflow = '';
  // Satt när popupen öppnats programmatiskt via SvdUpsellPopup.offer() (t.ex.
  // från Svd variant selector). Då lägger popupen INTE i varukorgen själv —
  // den returnerar valda upsell-varianter och blocket gör sitt eget /cart/add.
  var programmaticResolve = null;

  function getPopup() {
    return document.querySelector('upsell-popup[data-upsell-popup]');
  }

  function cartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js';
  }

  /* ---- Interception ------------------------------------------------------
     UpCart kapar add-knappens CLICK (lyssnar på [name="add"]/type=submit) och
     gör sitt eget /cart/add. Därför måste vi avbryta på CLICK i capture-fas på
     document-nivå — capture går document -> knapp, så vår lyssnare körs FÖRE
     UpCarts lyssnare som sitter på själva knappen. stopImmediatePropagation
     stoppar både UpCart och formulärets submit. 'submit' behålls som fallback
     (t.ex. Enter-tangent i ett fält).
  ------------------------------------------------------------------------- */

  document.addEventListener('click', onClickCapture, true);
  document.addEventListener('submit', onSubmitCapture, true);

  function getMainForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function intercept(e, form) {
    popup = getPopup();
    if (!popup) return; // Popup ej aktiverad för denna produkt -> låt temat/UpCart sköta allt
    if (!form) form = getMainForm();
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    capturedData = new FormData(form);
    bindOnce();
    open();
  }

  function onClickCapture(e) {
    if (!e.target.closest) return;
    // Ignorera klick inuti popupen (CTA-knappar etc.)
    if (e.target.closest('upsell-popup')) return;

    var btn = e.target.closest('button[name="add"], .single-add-to-cart-button');
    if (!btn) return;
    // Bara huvud-/sticky-produktformulär (inte quick-add på kort)
    if (!btn.closest('product-form')) return;

    intercept(e, btn.closest('form[data-type="add-to-cart-form"]'));
  }

  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    intercept(e, form);
  }

  /* ---- Popup öppna/stäng ------------------------------------------------- */

  function open() {
    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    popup.hidden = false;
    // Tvinga reflow så transitionen körs
    void popup.offsetWidth;
    popup.classList.add('is-open');
    document.addEventListener('keydown', onKeydown);
    var firstBtn = popup.querySelector('.upsell-popup__close');
    if (firstBtn) firstBtn.focus();
  }

  function close() {
    popup.classList.remove('is-open');
    document.removeEventListener('keydown', onKeydown);
    document.body.style.overflow = prevBodyOverflow;
    var dialog = popup.querySelector('.upsell-popup__dialog');
    var done = function () {
      popup.hidden = true;
      if (dialog) dialog.removeEventListener('transitionend', done);
    };
    if (dialog) {
      dialog.addEventListener('transitionend', done);
      // Fallback om transitionend inte triggas
      setTimeout(done, 400);
    } else {
      done();
    }
    // Stängd utan att bekräfta (X/backdrop/Escape) = hoppa över upsellen.
    // No-op i det normala flödet (programmaticResolve är då null).
    resolveProgrammatic([]);
  }

  function closeImmediate() {
    popup.classList.remove('is-open');
    popup.hidden = true;
    document.removeEventListener('keydown', onKeydown);
    document.body.style.overflow = prevBodyOverflow;
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
  }

  /* ---- Event-delegation inom popupen ------------------------------------ */

  function bindOnce() {
    if (bound) return;
    bound = true;

    popup.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-up-close]')) {
        close();
        return;
      }

      var toggle = t.closest('[data-up-toggle]');
      if (toggle) {
        var card = toggle.closest('[data-up-card]');
        if (card) {
          var selected = card.classList.toggle('is-selected');
          toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
        }
        return;
      }

      var confirmBtn = t.closest('[data-up-confirm]');
      if (confirmBtn) {
        confirm(confirmBtn.hasAttribute('data-up-skip'), confirmBtn);
        return;
      }
    });
  }

  /* ---- Lägg i varukorg --------------------------------------------------- */

  function buildItems(includeDeals) {
    var items = [];
    var main = {
      id: capturedData.get('id'),
      quantity: Number(capturedData.get('quantity')) || 1
    };
    var props = {};
    capturedData.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) {
        props[m[1]] = value;
      } else if (key === 'selling_plan' && value) {
        main.selling_plan = value;
      }
    });
    if (Object.keys(props).length) main.properties = props;
    items.push(main);

    if (includeDeals) {
      popup.querySelectorAll('.upsell-card.is-selected[data-variant-id]').forEach(function (card) {
        // Dold flagga (_-prefix = göms för kunden) så rabatt-functionen vet att
        // raden lagts till via popupen och bara då applicerar popup_deal_price.
        items.push({ id: card.dataset.variantId, quantity: 1, properties: { _popup_deal: '1' } });
      });
    }
    return items;
  }

  function resolveProgrammatic(ids) {
    if (!programmaticResolve) return;
    var r = programmaticResolve;
    programmaticResolve = null;
    r(ids || []);
  }

  function collectSelectedVariantIds() {
    var ids = [];
    if (!popup) return ids;
    popup.querySelectorAll('.upsell-card.is-selected[data-variant-id]').forEach(function (card) {
      if (card.dataset.variantId) ids.push(card.dataset.variantId);
    });
    return ids;
  }

  function confirm(skip, btn) {
    // Programmatiskt läge (öppnad via SvdUpsellPopup.offer från ett custom-block,
    // t.ex. Svd variant selector): returnera valda upsell-varianter och låt
    // blocket göra sitt eget /cart/add. Vi lägger INTE i varukorgen här.
    if (programmaticResolve) {
      var pickedIds = skip ? [] : collectSelectedVariantIds();
      closeImmediate();
      resolveProgrammatic(pickedIds);
      return;
    }

    if (busy || !capturedData) return;
    busy = true;

    var cta = popup.querySelector('[data-up-confirm]:not([data-up-skip])');
    var labelEl = cta;
    var originalLabel = cta ? cta.textContent : '';
    if (cta) {
      cta.setAttribute('aria-busy', 'true');
      if (popup.dataset.addingLabel) cta.textContent = popup.dataset.addingLabel;
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: buildItems(!skip),
        sections: SECTIONS.map(function (s) { return s.section; }).join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) {
          // Shopify-fel (t.ex. slut i lager)
          console.error('[upsell-popup]', resp.description || resp.message);
          resetCta(cta, originalLabel);
          return;
        }
        updateCartBubble(resp);
        dispatch('cart:item-added', { product: resp.items ? resp.items[0] : resp });
        closeImmediate();
        resetCta(cta, originalLabel);
      })
      .catch(function (err) {
        console.error('[upsell-popup]', err);
        resetCta(cta, originalLabel);
      });
  }

  function resetCta(cta, label) {
    busy = false;
    if (cta) {
      cta.removeAttribute('aria-busy');
      cta.textContent = label;
    }
  }

  /* ---- Uppdatera bara temats header-räknare (öppna ALDRIG native drawer) -- */

  function updateCartBubble(parsed) {
    if (!parsed.sections) return;
    SECTIONS.forEach(function (s) {
      if (!parsed.sections[s.section]) return;
      var el = document.getElementById(s.id);
      if (!el) return;
      var target = el.querySelector(s.selector) || el;
      try {
        target.innerHTML = getSectionInnerHTML(parsed.sections[s.section], s.selector);
      } catch (e) { /* ignorera – UpCart visar ändå sin egen räknare */ }
    });
  }

  function getSectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function dispatch(name, data) {
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent(name, data || {});
    } else {
      document.dispatchEvent(new CustomEvent(name, data ? { detail: data } : null));
    }
  }

  /* ---- Publikt API för custom-block (Svd variant selector, bundle m.fl.) ---
     Öppnar popupen programmatiskt och resolvar med valda upsell-variant-ID:n.
     Blocket gör SJÄLV sitt /cart/add (och måste tagga upsell-raderna med
     properties: { _popup_deal: '1' } för att deal-priset ska gälla, precis som
     buildItems gör). Finns ingen popup / inga deals på sidan, eller hoppar
     kunden över, resolvar den [] -> blocket beter sig exakt som utan popup.
     Click-interceptorn ovan rörs inte. -------------------------------------- */
  function offer() {
    return new Promise(function (resolve) {
      var p = getPopup();
      if (!p) { resolve([]); return; }                          // ingen popup på sidan
      if (busy || programmaticResolve) { resolve([]); return; } // redan upptagen
      if (!p.querySelector('.upsell-card[data-variant-id]')) { resolve([]); return; } // inga deals -> visa inte tom popup
      popup = p;
      bindOnce();
      programmaticResolve = resolve;
      open();
    });
  }

  window.SvdUpsellPopup = { offer: offer };
})();
